export interface CSVQuestionRow {
  Cle: string;
  Principe: string;
  Question: string;
  'Réponse A': string;
  'Réponse B': string;
  'Réponse C': string;
  'Réponse D': string;
  'Bonne réponse': string;
  Commentaire: string;
}

export interface Question {
  image: string;
  principe: string;
  text: string;
  choices: string[];
  answer: string;
  comment: string;
}

export interface QuestionAnswered extends Question {
  isCorrect?: boolean;
}

export type Principle =
  | 'act for users not buyers'
  | 'aim higher'
  | 'intention over processes'
  | 'lucca first'
  | 'make it simple'
  | 'speak your mind'
  | 'think for 5 years, act for next monday'
  | 'transparency by default'
  | 'work seriously without taking yourself too seriously';

export type IMAGE_KEYS = '01_roi' | '02_chevalier' | '03_archer' | '04_barde' | '05_fee' | '06_druide' | '07_fou' | '08_voyante' | '09_elfe';

export const IMAGE_TO_PRINCIPE: Record<IMAGE_KEYS, Principle> = {
  '01_roi': 'lucca first',
  '02_chevalier': 'act for users not buyers',
  '03_archer': 'aim higher',
  '04_barde': 'speak your mind',
  '05_fee': 'make it simple',
  '06_druide': 'intention over processes',
  '07_fou': 'work seriously without taking yourself too seriously',
  '08_voyante': 'think for 5 years, act for next monday',
  '09_elfe': 'transparency by default',
};

export const CURSORS_STORAGE_KEY = 'lucca.devfest.principles';
